import { useHandlers } from '@sparklayer-io/spark-dash-pages/context/page-context';

import type { PlatformApiContract } from '../api';

export function usePlatformApi(): { platformApi: PlatformApiContract } {
  const { apis } = useHandlers();
  if (!apis.platform) {
    throw new Error(
      'apis.platform is missing. Mount this page with `buildApis` from @sparklayer-io/dashboard.',
    );
  }
  return { platformApi: apis.platform };
}
